module.exports = __webpack_public_path__ + "img/after3.ea8f1f4f.jpg";